export const SET_ACTIVE_THREAD = "SET_ACTIVE_THREAD";